"use client";

import { AlertCircle, RefreshCw } from "lucide-react";

export default function GlobalError({}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="es">
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen px-6 text-center gap-6 font-sans">
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-100">
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
          <div className="space-y-2 max-w-md">
            <h2 className="text-xl font-semibold">Algo salió mal</h2>
            <p className="text-sm text-gray-500">
              Ocurrió un error inesperado. Podés intentar nuevamente.
            </p>
          </div>
          <div className="flex gap-3">
            <a
              href="/"
              className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium"
            >
              Volver al inicio
            </a>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 px-4 py-2 bg-black text-white rounded-md text-sm font-medium"
            >
              <RefreshCw className="w-4 h-4" />
              Reintentar
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
